import { TwoSwitch } from "../lib/iprs-react-library/src/index";
import Check from           './images/check.svg';

// QBE MIRS (PartyID 196845) has its own bespoke confirmation wording.
// See ClientNames.cs (QBEMIRS) in iprs-api.
const QBE_MIRS_CLIENT_ID = 196845;

/**
 * Thanks you page that will be displayed when form has been successfully submitted.
 * @param {object} props
 * @returns
 */
const Thanks = ({caseRef, bookingURL, suppressDiaryLink, clientId, anotherReferral}) => {

    // When 'Book a diary slot' button is clicked in the Thank you page,
    // window.location.replace(bookingURL) will direct the user to booking page.
    const bookDiarySlot = () => {
        window.location.replace(bookingURL);
    }

    const isQbeMirs = Number(clientId) === QBE_MIRS_CLIENT_ID;

    return <div className="container">
        <div className="typography">
            <div className="checkContainer">
                <img alt="Check Sign Icon" className="check" src={Check} />
            </div>

            <TwoSwitch test={isQbeMirs} >
                <p>Thank you for submitting your referral to IPRS Health.
                    The IPRS Health Customer Service team will contact the
                    patient within the agreed SLA.
                </p>
                <p>Thank you for submitting
                    your referral to IPRS Health. You will receive a
                    confirmation email within the next 30 minutes confirming
                    the IPRS Health Case ID for future reference. If you have
                    any concerns or do not receive this email please do not
                    hesitate to contact IPRS Health on 0800 072 1227 or email&nbsp;
                    <a href="mailto:health@iprsgroup.com">health@iprsgroup.com</a>.
                </p>
            </TwoSwitch>

            <p style={{ textAlign: 'center', marginTop: '30px' }}>Click <a id="anotherSubmitLink" href='.' onClick={anotherReferral}>here</a> to submit another referral.</p>

            <TwoSwitch test={bookingURL && !suppressDiaryLink} >
                <button style={{ display: 'flex', marginBottom: '40px' }} onClick={() => bookDiarySlot()}>Book a diary slot</button>
            </TwoSwitch>
        </div>
    </div>
}

export default Thanks;

